// Modul zur Erfassung von Honorar-Kosten
"use strict";

import module from "./module.js";
// import "./tests.spec.js";

export default module;
